import { Button, Stack, styled } from '@mui/material'
import { ChainInfo } from 'api/v1/chains'
import Loading from 'components/Loading'
import { memo, useState } from 'react'
import { useCurrentNetwork, useSupportChains } from 'store/app/hooks'
import { Flex } from 'styles'
import { FaucetTips, GrayWrap } from './styles'

import { useSwitchNetwork } from '../../hooks/web3/useSwitchNetwork'

const CoinItem = styled('div')`
  height: 48px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  margin-right: 4px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid rgba(255, 255, 255, 0);
  color: ${(props) => props.theme.color.text100};
  &.active,
  &:hover {
    background: ${(props) => props.theme.color.bg};
    border: 1px solid ${(props) => props.theme.color.primary30};
  }
  &.network {
    &.active,
    &:hover {
      background: ${(props) => props.theme.color.text60};
      border: none;
      color: ${(props) => props.theme.color.text00};
    }
  }
`
const CoinItemLeft = styled(Flex)`
  align-items: center;
`

const ListWrap = styled('div')`
  max-height: 200px;
  overflow-y: auto;
`

const CoinImg = styled('img')`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  border-radius: 50%;
  &.network {
    border-radius: 8px;
  }
`
const CoinName = styled('div')`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`

export const FaucetNetworkSelection = memo(() => {
  const supportChains = useSupportChains()
  const [selectedNetWork, setSelectedNetWork] = useState<ChainInfo>()
  const currentNetwork = useCurrentNetwork()
  const switchNetwork = useSwitchNetwork()
  const [isPending, setIsPending] = useState(false)

  const onSwitchNetwork = () => {
    if (
      selectedNetWork &&
      selectedNetWork.layerTwoChainId !== currentNetwork?.layerTwoChainId
    ) {
      setIsPending(true)

      console.log(selectedNetWork.layerOneChainId)
      switchNetwork(selectedNetWork.layerOneChainId)
        .catch((e) => {})
        .finally(() => {
          setIsPending(false)
        })
    }
  }

  return (
    <Stack spacing={2}>
      <GrayWrap spacing={1}>
        <FaucetTips>Please switch to a supported network</FaucetTips>
        <ListWrap>
          {supportChains.map((item) => {
            const { name, iconUrl, chainId } = item
            return (
              <CoinItem
                key={chainId}
                onClick={() => setSelectedNetWork(item)}
                className={`network ${
                  chainId === selectedNetWork?.chainId ? 'active' : ''
                }`}>
                <CoinItemLeft>
                  <CoinImg className="network" src={iconUrl}></CoinImg>
                  <CoinName>{name}</CoinName>
                </CoinItemLeft>
              </CoinItem>
            )
          })}
        </ListWrap>
      </GrayWrap>
      <Button
        variant="contained"
        fullWidth={true}
        className={!isPending ? 'active' : 'disable'}
        onClick={() => onSwitchNetwork()}>
        {isPending ? <Loading /> : null}
        <span>Switch Network</span>
      </Button>
    </Stack>
  )
})
